import { useState } from 'react';
import Dropdown from '../submissions-database/dropdown/Dropdown';
import MultiEntryField from '../submissions-database/MultiEntryField';
import SingleEntryField from '../submissions-database/SingleEntryField';
import SubmittedByDropdown from '../submissions-database/SubmittedByDropdown';
import DocPermissionEnum from 'enums/DocPermissionEnum';
import GENRE_OPTIONS from '../../constants/genreOptions';

function FieldLabel({ children }) {
  return (
    <span className="text-[10px] font-bold text-gray-500 uppercase tracking-wider block mb-2">
      {children}
    </span>
  );
}

export default function ReportDetailMetadata({ report }) {
  const [editingField, setEditingField] = useState({ field: '', itemId: '' });
  const [currentDropdown, setCurrentDropdown] = useState({ index: null, label: '' });

  const item = { ...report, _id: report._id };
  const canEdit = item?.actions?.includes(DocPermissionEnum.DOC_EDIT);

  return (
    <div className="mb-8 rounded-[10px] bg-surface border border-surface-border p-6">
      <h2 className="text-sm font-semibold text-white mb-6">Material details</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-5">
        <div>
          <FieldLabel>Type</FieldLabel>
          <Dropdown
            item={item}
            values={['FILM', 'TV', 'BOOK']}
            defaultValue={item?.type}
            dropdownClass="!w-full"
            title="Type"
            label="type"
            currentDropdown={currentDropdown}
            setCurrentDropdown={setCurrentDropdown}
            isSubmissionType
            index={0}
            canEdit={canEdit}
          />
        </div>

        <div>
          <FieldLabel>Genre</FieldLabel>
          <Dropdown
            item={item}
            values={GENRE_OPTIONS}
            defaultValue={item?.genre}
            dropdownClass="!w-full"
            title="Genre"
            label="genre"
            currentDropdown={currentDropdown}
            setCurrentDropdown={setCurrentDropdown}
            isMultiEntry
            isSubmissionType
            index={0}
            canEdit={canEdit}
          />
        </div>

        <div>
          <FieldLabel>Title</FieldLabel>
          <SingleEntryField
            defaultValue={item.title}
            fieldName="title"
            item={item}
            editingField={editingField}
            setEditingField={setEditingField}
            fieldWidth="100%"
            canEdit={canEdit}
          />
        </div>

        <div>
          <FieldLabel>Submitted by</FieldLabel>
          <SubmittedByDropdown
            item={item}
            currentDropdown={currentDropdown}
            setCurrentDropdown={setCurrentDropdown}
            canEdit={canEdit}
          />
        </div>

        <div className="md:col-span-2">
          <FieldLabel>Writers / Directors / Producers</FieldLabel>
          <MultiEntryField
            fieldNames={['writer', 'directors', 'producers']}
            item={item}
            editingField={editingField}
            setEditingField={setEditingField}
            fieldWidth="100%"
            canEdit={canEdit}
          />
        </div>

        <div className="md:col-span-2">
          <FieldLabel>Logline</FieldLabel>
          <SingleEntryField
            defaultValue={item?.logline}
            fieldName="logline"
            item={item}
            editingField={editingField}
            setEditingField={setEditingField}
            isTextArea
            canEdit={canEdit}
          />
        </div>

        <div>
          <FieldLabel>Note</FieldLabel>
          <SingleEntryField
            defaultValue={item?.note}
            fieldName="note"
            item={item}
            editingField={editingField}
            setEditingField={setEditingField}
            isTextArea
            canEdit={canEdit}
          />
        </div>

        <div>
          <FieldLabel>Based on</FieldLabel>
          <SingleEntryField
            defaultValue={item?.based_on}
            fieldName="based_on"
            item={item}
            editingField={editingField}
            setEditingField={setEditingField}
            isTextArea
            canEdit={canEdit}
          />
        </div>

        <div>
          <FieldLabel>Read</FieldLabel>
          <Dropdown
            item={item}
            values={['Unread', 'Read']}
            defaultValue={item?.read ? 'Read' : 'Unread'}
            containerClass="w-full"
            title="Read"
            label="read"
            isBoolean
            currentDropdown={currentDropdown}
            setCurrentDropdown={setCurrentDropdown}
            index={0}
            canEdit={canEdit}
          />
        </div>

        <div>
          <FieldLabel>Responded</FieldLabel>
          <Dropdown
            item={item}
            values={['No Response', 'Responded']}
            defaultValue={item?.response_status ? 'Responded' : 'No Response'}
            containerClass="w-full"
            title="Response Status"
            label="response_status"
            isBoolean
            currentDropdown={currentDropdown}
            setCurrentDropdown={setCurrentDropdown}
            index={0}
            canEdit={canEdit}
          />
        </div>

        <div>
          <FieldLabel>Priority</FieldLabel>
          <Dropdown
            item={item}
            values={['Project Drafts', 'Project Samples', 'Available Material', 'General']}
            defaultValue={item?.priority || 'General'}
            containerClass="w-full"
            title="Priority"
            label="priority"
            currentDropdown={currentDropdown}
            setCurrentDropdown={setCurrentDropdown}
            index={0}
            canEdit={canEdit}
          />
        </div>
      </div>
    </div>
  );
}
